<router-outlet />

@if (updateAvailable()) {
<div class="mst-dialog-overlay">
    <mst-dialog (closed)="dismissUpdate()" class="relative">
        <header class="mst-dialog__header stack xEnd row pr16 pt16">
            <button type="button" class="mst-dialog__close" aria-label="Chiudi" (click)="dismissUpdate()">
                <i class="mst-icon-close" aria-hidden="true"></i>
            </button>
        </header>
        <div class="mst-dialog__content px16">
            <div class="mst-dialog__title-section">
                <h2 class="mst-dialog__title">Nuova versione disponibile</h2>
            </div>
            <p class="pt16">
                È disponibile un aggiornamento dell'app. <br />
                Aggiorna ora per continuare a usare la versione più recente.
            </p>
        </div>
        <footer class="mst-dialog__footer">
            <button type="button" mst-button variant="solid" (click)="applyUpdate()">Aggiorna ora</button>
        </footer>
    </mst-dialog>
</div>
}
